var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.load },
              model: {
                value: _vm.active,
                callback: function ($$v) {
                  _vm.active = $$v
                },
                expression: "active",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "卡券核销", name: "verify" },
              }),
              _c("el-tab-pane", {
                attrs: { label: "已售卡券", name: "cards" },
              }),
              _c("el-tab-pane", {
                attrs: { label: "核销记录", name: "records" },
              }),
              _c("el-tab-pane", {
                attrs: { label: "核销员", name: "verifiers" },
              }),
            ],
            1
          ),
          _vm.active === "verify"
            ? _c(
                "div",
                { staticClass: "verify-panel" },
                [
                  _c(
                    "el-form",
                    { attrs: { "label-width": "100px", size: "small" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡券编号" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "输入卡券编号" },
                            model: {
                              value: _vm.verifyForm.cardNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.verifyForm,
                                  "cardNo",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "verifyForm.cardNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "核销次数" } },
                        [
                          _c("el-input-number", {
                            attrs: { min: 1, max: 999 },
                            model: {
                              value: _vm.verifyForm.verifyTimes,
                              callback: function ($$v) {
                                _vm.$set(_vm.verifyForm, "verifyTimes", $$v)
                              },
                              expression: "verifyForm.verifyTimes",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["distribution:store:card:verify"],
                                  expression:
                                    "['distribution:store:card:verify']",
                                },
                              ],
                              attrs: {
                                type: "primary",
                                loading: _vm.saving,
                                icon: "el-icon-check",
                              },
                              on: { click: _vm.verify },
                            },
                            [_vm._v("确认核销")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.verifyResult
                    ? _c("el-alert", {
                        attrs: {
                          type: "success",
                          closable: false,
                          "show-icon": "",
                          title:
                            "核销成功，剩余 " +
                            _vm.verifyResult.remainTimes +
                            " 次",
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : [
                _c(
                  "div",
                  { staticClass: "toolbar" },
                  [
                    _c("el-input", {
                      attrs: {
                        clearable: "",
                        placeholder: "用户昵称、手机号或用户ID",
                        size: "small",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.load($event)
                        },
                      },
                      model: {
                        value: _vm.query.keywords,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.query,
                            "keywords",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "query.keywords",
                      },
                    }),
                    _vm.active !== "verifiers"
                      ? _c("el-input", {
                          attrs: {
                            clearable: "",
                            placeholder: "卡券编号",
                            size: "small",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.load($event)
                            },
                          },
                          model: {
                            value: _vm.query.cardNo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.query,
                                "cardNo",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "query.cardNo",
                          },
                        })
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-search",
                        },
                        on: { click: _vm.load },
                      },
                      [_vm._v("查询")]
                    ),
                    _vm.active === "verifiers"
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "distribution:store:card:verifier:save",
                                ],
                                expression:
                                  "['distribution:store:card:verifier:save']",
                              },
                            ],
                            attrs: {
                              type: "primary",
                              size: "small",
                              icon: "el-icon-plus",
                            },
                            on: {
                              click: function ($event) {
                                _vm.verifierVisible = true
                              },
                            },
                          },
                          [_vm._v("添加核销员")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.active === "cards"
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        attrs: { data: _vm.rows, border: "", size: "small" },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "序号",
                            width: "60",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                                },
                              },
                            ],
                            null,
                            false,
                            3594593631
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "cardNo",
                            label: "卡券编号",
                            "min-width": "180",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "cardName",
                            label: "卡券名称",
                            "min-width": "180",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "orderNo",
                            label: "订单号",
                            "min-width": "180",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "cardTypeName",
                            label: "类型",
                            width: "100",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "usedTimes",
                            label: "已用",
                            width: "80",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "remainTimes",
                            label: "剩余",
                            width: "80",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "statusName",
                            label: "状态",
                            width: "100",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "endTime",
                            label: "有效期至",
                            "min-width": "155",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.active === "records"
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        attrs: { data: _vm.rows, border: "", size: "small" },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "序号",
                            width: "60",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                                },
                              },
                            ],
                            null,
                            false,
                            3594593631
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "cardNo",
                            label: "卡券编号",
                            "min-width": "180",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "cardName",
                            label: "卡券名称",
                            "min-width": "180",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "nickname",
                            label: "用户",
                            "min-width": "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "phone",
                            label: "手机号",
                            "min-width": "130",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "verifyTimes",
                            label: "核销次数",
                            width: "100",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "remainTimes",
                            label: "剩余次数",
                            width: "100",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "verifyAdminName",
                            label: "核销人",
                            "min-width": "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "createTime",
                            label: "核销时间",
                            "min-width": "155",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.active === "verifiers"
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        attrs: { data: _vm.rows, border: "", size: "small" },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "序号",
                            width: "60",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                                },
                              },
                            ],
                            null,
                            false,
                            3594593631
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "uid", label: "用户ID", width: "90" },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "nickname",
                            label: "昵称",
                            "min-width": "130",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "phone",
                            label: "手机号",
                            "min-width": "130",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "状态", width: "100" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: scope.row.status
                                            ? "success"
                                            : "info",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.status ? "启用" : "停用"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1164960566
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "operator",
                            label: "操作人",
                            "min-width": "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "createTime",
                            label: "设置时间",
                            "min-width": "155",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作", width: "150" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: [
                                              "distribution:store:card:verifier:save",
                                            ],
                                            expression:
                                              "['distribution:store:card:verifier:save']",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleVerifier(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.status ? "停用" : "启用"
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: [
                                              "distribution:store:card:verifier:save",
                                            ],
                                            expression:
                                              "['distribution:store:card:verifier:save']",
                                          },
                                        ],
                                        staticClass: "danger",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeVerifier(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("移除")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2698188587
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    "current-page": _vm.query.page,
                    "page-size": _vm.query.limit,
                    total: _vm.total,
                    layout: "total, prev, pager, next",
                  },
                  on: { "current-change": _vm.pageChange },
                }),
              ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加核销员",
            visible: _vm.verifierVisible,
            width: "460px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.verifierVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "90px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "手机号" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "20" },
                    model: {
                      value: _vm.verifierPhone,
                      callback: function ($$v) {
                        _vm.verifierPhone =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "verifierPhone",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.verifierVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.saveVerifier },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }